import { useNavigate, useParams } from 'react-router-dom'
import { FormClientes } from '../../../components/Forms/FormClientes'
import Navbar from '../../../components/navbar/navbar'
import { useEffect, useRef, useState } from 'react'
import PessoasService from '../../../services/database/PessoasService'
import { toast } from 'react-toastify'

export function EditarCliente() {
  const [isCustomerUpdateLoading, setIsCustomerUpdateLoading] = useState(false)

  const navigate = useNavigate()
  const params = useParams()

  const formClientesRef = useRef(null)

  function handleNavigate() {
    navigate(-1)
  }

  async function getCustomer(customerId) {
    try {
      const customer = await PessoasService.getById(customerId)

      return customer
    } catch (error) {
      console.log(`Erro ao buscar usuário: ${error}`)
      toast.error(`Erro ao buscar usuário!`)
    }
  }

  async function handleSubmit(e) {
    e.preventDefault()

    setIsCustomerUpdateLoading(true)

    try {
      const customer = formClientesRef.current?.getCustomer()

      const { cod_pessoa, ...data } = customer

      await PessoasService.update(cod_pessoa, data)

      toast.success('Cliente editado com sucesso!')

      handleNavigate()
    } catch (err) {
      console.log(`Erro ao editar o cliente: ${err}`)
      return toast.error('Erro ao editar o cliente!')
    } finally {
      setIsCustomerUpdateLoading(false)
    }
  }

  useEffect(() => {
    ;(async () => {
      const customer = await getCustomer(params.id)

      formClientesRef.current.sendCustomer(customer)
    })()
  }, [params.id])

  return (
    <>
      <div className="mt-page">
        <Navbar />

        <FormClientes
          ref={formClientesRef}
          title="Editar Cliente"
          onBack={handleNavigate}
          onSubmit={handleSubmit}
          isRequestLoading={isCustomerUpdateLoading}
        />
      </div>
    </>
  )
}
